

import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form13";
const form13State = namespace("Form13");

import { form13DataInfoType, form13PartiesInfoType } from '@/types/Information/Form13';
import {getPartyTitles} from '../PartyTitlesForm13'


@Component
export default class Form13Layout extends Vue {

    @Prop({required:true})
    result!: form13DataInfoType; 

    @form13State.Action
    public UpdateForm13Info!: (newForm13Info: form13DataInfoType) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    
    applicantNamesFull = '';
    respondentNamesFull = '';
    extensionDate = '';
    applicationType = '';
    applyingParties = '';   
    signingPartyList = [];    

    mounted(){
        this.extractInfo();       
        this.dataReady = true;
    }
   
    public extractInfo(){        
       
        this.applicantNames = [];
        this.respondentNames = [];        

        for (const resInx in this.result.respondents){
            const fullTitle = getPartyTitles(this.result.respondents[resInx],' ')
            this.respondentNames.push(fullTitle);
        }
        this.respondentNamesFull = this.combineNames(this.result.respondents, '', this.respondentNames)
      

        for (const appInx in this.result.appellants){
            const fullTitle = getPartyTitles(this.result.appellants[appInx],' ')
            this.applicantNames.push(fullTitle);            
        }
        this.applicantNamesFull = this.combineNames(this.result.appellants, '', this.applicantNames)

        this.extensionDate = this.result.extensionDate;
        this.extractFilingParties();
        this.extractSeekingTypes();        
        
        this.extractSigningParties();
    }  

    public extractSigningParties(){
        
        const signingAppellants = this.result.signingParties.filter(party=> !party.responding)
        const signingRespondents = this.result.signingParties.filter(party=> party.responding)       

        this.extractSigningPartyList(signingAppellants, signingRespondents)
       
    }

    public extractFilingParties(){
        
        const applyingAppellants = this.result.filingParties.filter(party=> !party.responding)
        const applyingRespondents = this.result.filingParties.filter(party=> party.responding)
                     
        const appellantnames = this.combineNames(applyingAppellants, 'name', null, ', the appellant')            
        const respondentnames = this.combineNames(applyingRespondents, 'name', null, ', the respondent')         

        this.applyingParties += appellantnames
        this.applyingParties += (appellantnames && respondentnames)?' and ':''
        this.applyingParties += respondentnames 
    }

    public extractSigningPartyList(appearingAppellants, appearingRespondents){
        const allParties: form13PartiesInfoType[] = [...appearingAppellants, ...appearingRespondents]        
        this.signingPartyList =[]
        for(const party of allParties){
            if(!party.isCounsel){
                const sameParty = allParties.filter(par => {
                    return(
                        (par.organization && par.isOrganization && par.organization==party.organization) ||
                        (par.firstName && par.lastName && par.firstName == party.firstName && par.lastName == party.lastName)
                    )
                })
                if(sameParty.length==1) this.signingPartyList.push(party)
            }else{
                this.signingPartyList.push(party)
            }
        }
    }

    public extractSeekingTypes(){

        const otherTypeIndex = this.result.seekingExtension.findIndex(item =>item=='other')
        if(otherTypeIndex>-1){
            const seekingExtension = JSON.parse(JSON.stringify(this.result.seekingExtension))
            seekingExtension.splice(otherTypeIndex,1)
            seekingExtension.push(this.result.seekingExtensionOther)

            this.applicationType = this.combineNames(seekingExtension)
        }
        else 
            this.applicationType = this.combineNames(this.result.seekingExtension)
    }


    
    public combineNames(names, nameField?, addingNameArray?, role?){
        let namesString = ''
        
        const numberOfNames = names.length       
        for(const index in names){
            
            let addingName = ''
            const partyRole = role?role:'';            

            if(addingNameArray?.length>0){
                addingName = addingNameArray[index] + partyRole
            }
            else if(nameField)
                addingName = names[index][nameField] + partyRole
            else
                addingName = names[index] + partyRole

            if(Number(index)>0 && Number(index)+1 == numberOfNames)
                namesString += ' and '+addingName
            else if(Number(index)==0)
                namesString += addingName
            else
                namesString += ', '+addingName
        }
        return namesString
    }
}

